import * as yup from "yup";

export const EarningSummarySetupValidationSchema = yup.object().shape({});
